const getTradierURL = () => {
  return `https://api.tradier.com/v1/oauth/authorize?scope=read,trade,market&client_id=${process.env.REACT_APP_TRADIER_CLIENT_ID}&state=${process.env.REACT_APP_TRADIER_CLIENT_SC}`;
};

export default getTradierURL;
